export default function ExpoCell({ title, detail }) {
    return (
        <div className="flex flex-col">
            <div className="text-xs font-bold uppercase">{title}</div>
            <div>{detail}</div>
        </div>
    )
}